import { Col, Row } from 'antd';

import { ColorModel } from '~/core/models';
import { hasTrendingOrBestSelling } from '~/core/utils';
import SlabViewerContentText from '~atoms/SlabViewerContentText';
import SlabViewerTrendPreview from '~molecules/SlabViewerTrendPreview';
import SlabViewerMatAttr from '~organisms/SlabViewerMatAttr';

interface SlabViewerContentProps {
  previewColor: ColorModel;
  materialName: string;
}

const SlabViwerContent = ({
  previewColor,
  materialName,
}: SlabViewerContentProps): JSX.Element => {
  const trendLabel = hasTrendingOrBestSelling(previewColor.features);

  const MATERIAL_ATTRIBUTE = 'materialAttribute';

  const materialAttributes = previewColor.features.filter(
    (feature) => feature.name === MATERIAL_ATTRIBUTE
  );
  const slabPreviewURL = previewColor.slabImageUrl.replace('-thumbnail', '');

  return (
    <Row gutter={[20, 20]} wrap={false}>
      <SlabViewerMatAttr materialAttributes={materialAttributes} />
      <Col>
        <SlabViewerTrendPreview
          trendLabel={trendLabel ?? undefined}
          slabPreviewURL={slabPreviewURL}
        />
        <SlabViewerContentText materialName={materialName} />
      </Col>
    </Row>
  );
};

export default SlabViwerContent;
